import EnrollmentsList from './List'

export default function CampusListIndex({ enrollments, campuses, districtTypes }) {
  const activeCampuses = enrollments.campusEnrollments.filter(ce => ce.endDate === null)
  const inactiveCampuses = enrollments.campusEnrollments.filter(ce => ce.endDate !== null)

  return <EnrollmentsList campuses={campuses} activeCampuses={activeCampuses} inactiveCampuses={inactiveCampuses} districtTypes={districtTypes} />
}
